exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mayo-base-ui-default-style{font-family:\"Noto Sans, Noto Sans TC, Noto Sans SC, sans-serif\";letter-spacing:.5px;box-sizing:border-box;font-size:1rem;color:#333}.mayo-base-ui-wrap-all{white-space:pre-wrap;word-break:break-all;word-wrap:break-word;text-align:left}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/@mayo/xe-ui-kit/lib/style.css
 ** module id = 1988
 ** module chunks = 73
 **/